import { render, staticRenderFns } from "./clunyHill.vue?vue&type=template&id=18715170&scoped=true"
import script from "./clunyHill.vue?vue&type=script&lang=js"
export * from "./clunyHill.vue?vue&type=script&lang=js"
import style0 from "./clunyHill.vue?vue&type=style&index=0&id=18715170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18715170",
  null
  
)

export default component.exports